import React, { useContext } from "react";
import Logger from "../../../utils/Logger";
import { PublicComponentsWrapContext } from "../public/PublicComponentsWrap";
import Content from "./content/Content";
import { StyledContentLandingPageWrap, StyledContentWrap } from "./content/StyledContent";
import Footer from "./footer/Footer";
import MenuBar from "./menuBar/MenuBar";

import { StyledLandingPageWrap, StyledLayoutWrap } from "./StyledLayoutWrap";
import BackToTop from "./backToTop";
import { matchPath, useLocation } from "react-router";
import HomeIntroMenu from "../../pages/home/component/HomeIntroMenu";
import ContactAll from "../components/Contact/ContactAll";
import { StyleContactAll } from "../components/Contact/ContactAllStyled";
const Log = Logger.getLogger("LayoutWrap");

const ADMIN_PATHS = [
	"/booking",
	"/user",
	"/partner",
	"/business-licences",
	"/legal-entities",
	"/price-plans",
	"/payout-batches",
	"/station-requests",
	"/payment-channel-number",
	"/content-manage",
	"/text-editor",
	"/stations-text",
	"/homepage-text",
	"/admin-text",
	"/top-destination-manage",
	"/format-email",
	"/debt-management",
	"/debt-detail",
	"/partner-debt-detail",
	"/debt-history",
	"/notifications",
	"/country-rates",
	"/audit-logs",
	"/station-portal-logs",
	"/consent-logs",
	"/payment-cycle-settings",
	"/payment-surcharge-settings",
	"/system-config",
	"/service-interest-clicks",
	"/search-tracking",
	"/support-categories",
];

export default function LayoutWrap(props: {
	excludePattern?: string;
	includePaths?: string[];
	children: JSX.Element | JSX.Element[] | string | string[];
}) {
	const ctx = useContext(PublicComponentsWrapContext);
	const { pathname } = useLocation();

	const shouldRender = !(props.includePaths || []).every((includePath) => {
		const isMatching = matchPath(pathname, {
			path: includePath,
			exact: true,
		});
		return !isMatching;
	});

	if (!shouldRender) {
		return null;
	}

	const isAdminPage = ADMIN_PATHS.some((p) => pathname.startsWith(p));

	// Log.log(`rerender`);
	return (
		<>
			<StyledLandingPageWrap fullScreen={ctx?.isFullScreen}>
				<StyledContentLandingPageWrap fullScreen={ctx?.isFullScreen}>
					<HomeIntroMenu />
					<Content fullScreen={ctx?.isFullScreen}>{props.children}</Content>
					{!isAdminPage && <Footer />}
				</StyledContentLandingPageWrap>
				{!isAdminPage && (
					<StyleContactAll map={pathname === "/find-location"}>
						<ContactAll />
					</StyleContactAll>
				)}
			</StyledLandingPageWrap>
		</>
	);
}
